<template>
  <div>
    <b-row>
      <b-col sm="12">
        <b-collapse visible>
          <p class="mb-2">
            <label>
              Por favor tener en cuenta que las etiquetas generadas solo estarán
              disponibles por 2 horas
            </label>
            <b-button
              class="float-right"
              variant="primary"
              @click="reloadEtiquetas"
            >
              Actualizar consulta
            </b-button>
          </p>
          <b-table
            bordered
            class="mt-3"
            responsive
            striped
            hover
            :items="etiquetas"
            thead-tr-class="table-active"
            show-empty
            empty-text="No hay agendamientos para mostrar"
            :fields="columnas"
          >
            <template v-slot:cell(descargable)="data">
              <b-button
                variant="primary"
                v-if="data.item.descargable"
                @click="obtenerEtiquetas(data.item.id)"
              >
                <i class="fa fa-floppy-o"></i>
                Descargar
              </b-button>
            </template>
            <template v-slot:cell(estado_procesamiento)="data">
              <span v-if="!data.item.errores && data.item.estado_procesamiento">
                {{ data.item.estado_procesamiento }}
              </span>
              <span v-else>
                TERMINADO CON ERRORES <br />
                {{ data.item.errores }}
              </span>
            </template>
          </b-table>
        </b-collapse>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
import loader from "../../containers/loader";

export default {
  name: "etiquetasAgendadas",
  props: ["etiquetas", 'tipo_proceso'],
  data() {
    return {
      loading: false,
      columnas: [
        {
          key: "descargable",
          label: "Descargable",
          sortable: true,
          thStyle: {width: '130px !important', 'min-width': '130px !important', 'max-width': '130px !important'}
        },
        {
            key: "formato",
            label: "Formato",
            sortable: true,
            thStyle: {width: '90px !important', 'min-width': '90px !important', 'max-width': '90px !important'}
        },
        {
          key: "tipo",
          label: "Tipo de etiquetas",
          sortable: true,
        },
        {
          key: "fecha_solicitud",
          label: "Fecha de solicitud",
          sortable: true,
          thStyle: {width: '160px !important', 'min-width': '160px !important', 'max-width': '160px !important'}
        },
        {
          key: "fecha_generacion",
          label: "Fecha de generación",
          sortable: true,
          tdClass: "fechaGeneracion",
          thStyle: {width: '170px !important', 'min-width': '170px !important', 'max-width': '170px !important'}
        },
        {
          key: "estado_procesamiento",
          label: "Estado de generación",
          sortable: true,
          tdClass: "estadoGeneracion",
          thStyle: {width: '170px !important', 'min-width': '170px !important', 'max-width': '170px !important'}
        },
      ],
    };
  },
  components: {
    loader,
  },
  methods: {
    async reloadEtiquetas() {
      this.load(true);
      await this.listarEtiquetasAgendadas({id_empresa: this.selectedEmpresa.id, tipo_proceso: this.tipo_proceso});
      this.load(false);
    },
    async obtenerEtiquetas(id) {
      this.load(true);
      await this.descargarEtiquetasMasivo(id);
      if (!this.error) {
        this.DescargarArchivo(this.etiquetasArchivo);
      }
      this.load(false);
    },
    async DescargarArchivo(etiquetas) {
      window.open(process.env.VUE_APP_API_URL + etiquetas);
    },
    ...mapActions("etiquetas", [
      "descargarEtiquetasMasivo",
      "listarEtiquetasAgendadas",
    ]),
    ...mapMutations("dashboard", ["load"]),
  },
  computed: {
    ...mapState("etiquetas", [
      "etiquetasArchivo",
      "etiquetasProcesadas",
      "error",
    ]),
    ...mapState("empresa", ["selectedEmpresa"]),
  },
};
</script>
<style>
.descargableButton_etiquetas {
  width: 120px !important;
  max-width: 120px !important;
  min-width: 120px !important;
}
.tipo_etiquetas {
  width: 80px !important;
  max-width: 80px !important;
  min-width: 80px !important;
}
.fechaSolicitud {
  width: 100px !important;
  max-width: 100px !important;
  min-width: 100px !important;
}
.fechaGeneracion {
  width: 100px !important;
  max-width: 100px !important;
  min-width: 100px !important;
}
.estadoGeneracion {
  width: 140px !important;
  max-width: 140px !important;
  min-width: 140px !important;
}
</style>
